import { callApi } from "@/services/api"
import { CasinoGame, WheelOfFortuneConfig } from "@/services/types"
import { CasinoGameSlug } from "@/services/enums"

type CasinoGameResult = {
  data: CasinoGame<WheelOfFortuneConfig>
}

export async function getCasinoGame(): Promise<CasinoGameResult> {
  const response = await callApi.getCasinoGame<WheelOfFortuneConfig>(
    CasinoGameSlug.WheelOfFortune
  )

  return {
    data: response.data.data,
  }
}
